import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './css/index.scss';
import App from './App';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import 'react-day-picker/style.css';

import * as fi from './translations/fi/';

// Translations.
i18n.use(initReactI18next).init({
  lng: 'fi',
  resources: {
    fi: {
      common: fi.common,
      landingPage: fi.landingPage,
      myInfo: fi.myInfo,
      billing: fi.billing,
      contracts: fi.contracts,
      manageContracts: fi.manageContracts,
      consumption: fi.consumption,
      customerService: fi.customerService,
      header: fi.header,
      news: fi.news,
      evCharging: fi.evCharging,
    },
  },
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
  returnNull: false,
});

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
}
